<h-modal ariaLabelledby="''" class="align-center no-padding" id="" role="dialog">
    <div h-modal-body>
        <div class="adyen-container">
            <h-redirect-message [state]="state" [errorMessage]="errorMessage"></h-redirect-message>
        </div>
    </div>
</h-modal>
<div class="modal-background"></div>
